// extracted by mini-css-extract-plugin
module.exports = {"pagination":"carousel-pagination_pagination__O4PDR"};